import React, { useState } from "react";
import "../layout/css/style.css";
import Footer from "../layout/Footer.js";
import Lead_Form from "../widgets/forms/price/widget-action-form.js";
import ShortLeadForm from "../widgets/forms/price/short-lead-form.js";
import mentalhealth from "../assets/Images/banner-hearing-aids-centre.webp";
import PhonakAudeo from "../assets/Images/Phonak-Audeo.webp";
import Phonakinfinio from "../assets/Images/phonak-infinio.webp";
import PhonakMarvel from "../assets/Images/Phonak-Marvel.webp";
import Phonaknaida from "../assets/Images/Phonak-naida.webp";
import PhonakParadise from "../assets/Images/Phonak-Paradise.webp";
import phonakterra from "../assets/Images/phonak-terra.webp";
import LeadForm from "../widgets/forms/widget-action-form.js";
import "../layout/css/WidgetBrands.css";
import { Helmet } from "react-helmet";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import Bookhearingtest from "../assets/Images/book-a-free-hearing-test.webp";
import righthearingaids from "../assets/Images/find-the-right-hearing-aids.webp";

const hearingAids = [
    {
        title: "Phonak Infinio",
        tagline: "Perfect for: First-Time Hearing Aid Users | Comfortable Transition",
        features: [
            "Easy to use with adaptive sound enhancement",
            "Available in RIC fitting style",
            "Reliable performance for different listening situations",
            "User-friendly volume and program controls by myPhonak app.",
            "Comfortable and cost-effective for all age group"
        ],
        image: Phonakinfinio
    },
    {
        title: "Phonak Marvel",
        tagline: "Perfect for: Universal Connectivity | Balanced Hearing | Rich Audio",
        features: [
            "Streams audio from any Bluetooth device",
            "Rich stereo sound using binaural streaming",
            "Hands-free phone conversations and multiple Bluetooth connections",
            "Customizable programs via myPhonak App",
            "Rechargeable options available",
            "Excellent for tech-savvy people that enjoy smooth integration"
        ],
        image: PhonakMarvel
    },
    {
        title: "Phonak Paradise",
        tagline: "Perfect for: Natural Sound Quality | Motion Sensor Technology",
        features: [
            "Powered by PRISM chip and AutoSense OS 4.0",
            "Motion Sensor Hearing: adapts to your movement",
            "Tap Control: Answer calls, stream or access voice assistant",
            "Pairs with two Bluetooth devices at once",
            "Ultra-clear speech, even in noisy situation",
            "Cutting-edge technology designed to match today’s active and connected lifestyle"
        ],
        image: PhonakParadise
    },
    {
        title: "Phonak Audeo",
        tagline: "Perfect for: Mild to Moderate Hearing Loss | Active Lifestyle | Wireless Connectivity",
        features: [
            "Receiver-in-Canal (RIC) wireless connectivity design for privacy and comfort.",
            "Bluetooth compatibility with Android/iOS, TVs and computers.",
            "Calling hands-free with an integrated microphone.",
            "Rechargeable devices with all-day battery life.",
            "Adaptive sound with AutoSense OS for noise handling.",
            "Great for: Working professionals and seniors on-the-go."
        ],
        image: PhonakAudeo
    },
    {
        title: "Phonak Naida",
        tagline: "Perfect for: Severe to Profound Hearing Loss | Speech Clarity in Noise",
        features: [
            "Ultra-power Behind-the-Ear (BTE) model",
            "Advanced SmartSpeech Technology for better clarity",
            "Bluetooth audio streaming + RogerDirect (Mic) compatibility",
            "Rechargeable or battery-powered options",
            "Dust and water-resistant for daily durability",
            "Ideal for: Adults and seniors with significant hearing loss"

        ],
        image: Phonaknaida
    },
    {
        title: "Phonak Terra",
        tagline: "Perfect for: Budget-Friendly Digital Hearing | Everyday Use",
        features: [
            "Designed specifically for sound clarity for both quiet and noisy environments.",
            "Equipped with excellent sound processing digital solution at an affordable price.",
            "Comfortable, lightweight, and discrete.",
            "Comes in easy-to-wear BTE (Behind-The-Ear) styles for a comfortable fit.",
            "An affordable choice that maintains dependable performance and quality.",



        ],
        image: phonakterra
    }
];

const PhonakHearingAids = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const rows = [];

    for (let i = 0; i < hearingAids.length; i += 2) {
        rows.push(hearingAids.slice(i, i + 2));
    }
    return (
        <>
            <Helmet>
                <title>Phonak Hearing Aids in Delhi - Affordable Prices</title>
                <meta name="description" content="Explore top-rated hearing aids in Delhi with  consultation and trial. Book today!" />
                <meta charset="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta http-equiv="x-ua-compatible" content="ie=edge" />

                <meta name="description"
                    content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
                <meta name="robots" content="INDEX, FOLLOW" />
                <link rel="canonical" href="https://ads.soundforlife.in/phonak-hearing-aids" />
                <meta name="DC.title"
                    content="Best hearing aid solution - Book a hearing aid trial now - Sound For Life Hearing Solutions" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="Sound For Life Hearing Solutions" />
                <meta property="og:title"
                    content="Best hearing aid solution - Book a hearing aid trial now - Sound For Life Hearing Solutions" />
                <meta property="og:description"
                    content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
                <meta property="og:type" content="Website" />
                <meta property="og:image" content="https://ads.soundforlife.in/assets/images/og-image.jpg" />
                <meta property="og:image:type" content="image/jpeg" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt"
                    content="Best hearing aid solution - Book a hearing aid trial now - Sound For Life Hearing Solutions" />
                <meta property="og:url" content="https://ads.soundforlife.in/phonak-hearing-aids" />
                <link rel="preload" as="image" href={mentalhealth} />
            </Helmet>
            {/* Header Section */}
            <header className="bg-primary bg-opacity-50 py-5">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Banner Column */}

                        <div className="col-lg-7 position-relative">
                            <div className="position-relative">
                                <img
                                    src={mentalhealth} width="190" height="143" alt="hearing aids" fetchpriority="high"

                                    className="img-fluid w-100 rounded shadow lcp-img"

                                />
                                <div className="banner-overlay position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white p-4">
                                    <h1 className="h2 h1-md fw-bold">Phonak Hearing Aids - Hear the World Naturally
                                        Again</h1>
                                    <p className="mb-0">
                                        <span className="tag bg-success fw-bold me-2">
                                            <i className="fa-solid fa-users me-1"></i> Hear Better
                                        </span>
                                        <span className="tag bg-success fw-bold me-2">
                                            <i className="fa-solid fa-microchip me-1"></i> Feel Confident Again
                                        </span>
                                        <span className="tag bg-success fw-bold">
                                            <i className="fa-solid fa-indian-rupee-sign me-1"></i> Affordable Prices
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Form Column */}

                        <div className="col-lg-5">

                            <Lead_Form />
                        </div>

                    </div>
                </div>
            </header>

            {/* Main Content Section */}
            <div className="container mt-5">
                {/* Bullet Points */}
                <div className="mb-4 text-center">
                    <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
                        <i className="fa-solid fa-check-circle text-success me-1"></i> Hearing Test
                    </span>
                    <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
                        <i className="fa-solid fa-check-circle text-success me-1"></i> Branded Digital Hearing Aids
                    </span>
                    <span className="d-block d-md-inline-block fs-4">
                        <i className="fa-solid fa-check-circle text-success me-1"></i> Expert Audiologists
                    </span>
                </div>

                {/* Intro */}
                {/*  <h2 className="section-title">
                    Looking for a “Signia Hearing Aid Center Near Me”?
                </h2> */}

                <h2 className="fw-bold display-6 title">Looking for a <span className="title-info">"Phonak Hearing Aid Center Near Me”</span></h2>
                <p>
                    <i className="fa-solid fa-location-dot text-primary me-1 font-icon" ></i>
                    At SFL Hearing Solutions, we offer the full range of <span className="tag">Phonak hearing aids</span>. These devices give
                    you clear sound, modern designs, and smart features like Bluetooth. Visit any of our clinics
                    in India for a hearing test and live demo. Try them and feel the difference!
                </p>

            </div>

            {/* Best Brand We Offer */}
            {/* Signia Hearing Aids FeaFeatured */}
            <section className="container hearing-cards-container mt-5">
                <h3 className="section-title text-center">
                    Featured Phonak Models and Their Key Features
                </h3>
                <div className="hearing-section">
                    {rows.map((row, rowIndex) => (
                        <div className="hearing-row d-flex flex-wrap gap-4" key={rowIndex}>
                            {row.map((aid, index) => (
                                <div className="hearing-card flex-grow-1" key={index}>
                                    <div className="hearing-image text-center">
                                        <img src={aid.image} alt={aid.title} />
                                    </div>
                                    <div className="hearing-content d-flex flex-column h-100">
                                        <h3 className="titlehearingaids">{aid.title}</h3>
                                        <p className="small mb-3 tagline"><strong>{aid.tagline}</strong></p>
                                        <ul className="feature-list">
                                            {aid.features.map((feature, i) => (
                                                <li key={i}>
                                                    <i className="fa-solid fa-check-circle text-success me-2"></i>
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                    <div className="text-center">
                        <a onClick={() => setIsFormOpen(true)} href="#shortform" className="btn download-btn shadow fw-bold">
                            <i className="fa-solid fa-calendar-plus me-2"></i> Try Phonak Hearing Aids
                        </a> {isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}
                    </div>
                </div>
            </section>
            {/* Hearing Aids Section */}

            <section className="container mt-3">
                <h3 className="section-title mb-4 text-center">
                    Visit Your Nearest Center or Schedule a Home Visit.
                </h3>

                <p className="mb-3">
                    <strong>SFL Hearing Solutions</strong> proudly provides trusted hearing care services across
                    <strong> Delhi</strong>, <strong>Ghaziabad</strong>, <strong>Noida</strong>, <strong>Faridabad</strong>, and <strong>Gurgaon</strong>.
                </p>

                <p className="mb-3">
                    If you're searching online for terms like <em><span className="tag me-2">“hearing aid clinic near me”</span></em> <em><span className="tag me-2">“ear machine shop near me”</span></em>
                    <em><span className="tag me-2">“Phonak hearing aid center near me”</span></em> or <em><span className="tag me-2">“digital hearing aids cost”</span></em> there's a high chance you'll find us at the top.
                </p>

                <p className="mb-3">
                    At <strong>SFL Hearing Solutions</strong>, our friendly and experienced audiologists are here to help you or your loved ones
                    find the right hearing solution - whether you're looking for an invisible ear machine, a budget-friendly digital aid,
                    or simply expert advice that cares.
                </p>
            </section>

            {/* Hearing Aids Type and Offer */}

            {/* Right Hearing Device */}

            <section className="container mt-5">
                <div className="row align-items-center">
                    <div className="col-md-7">
                        <h4 className="fw-bold mb-4 heading">
                            <i className="fa-solid fa-ear-listen me-2"></i>
                            Find the Right Hearing Device for You
                        </h4>
                        <p className="fs-5 text-muted">
                            Whether you call it a hearing machine, ear device, <em>kan wali machine</em>, or ear sound machine - we have the perfect solution for:
                        </p>

                        <ul className="list-unstyled fs-5 mt-3">
                            <li><i className="fa-solid fa-check-circle text-success me-2"></i> Mild to profound hearing loss</li>
                            <li><i className="fa-solid fa-check-circle text-success me-2"></i> One ear or both ears</li>
                            <li><i className="fa-solid fa-check-circle text-success me-2"></i> Senior citizens</li>
                            <li><i className="fa-solid fa-check-circle text-success me-2"></i> Young adults and working professionals</li>
                        </ul>

                        <div className="mt-3">
                            <a onClick={() => setIsFormOpen(true)} href="#shortform" className="btn download-btn shadow fw-bold">
                                <i className="fa-solid fa-calendar-plus me-2"></i> Book a hearing aid Demo
                            </a> {isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}
                        </div>
                    </div>

                    <div className="col-md-5 mt-4 mt-md-0 text-center">
                        <img src={righthearingaids} alt="Main" className="main-img" />
                    </div>
                </div>
            </section>

            {/* Final CTA */}

            <section className="container">
                <div className="container">
                    <div className="cta-section text-center my-5">
                        <p className="h4">
                            <strong>
                                <i className="fa-solid fa-volume-high me-2"></i> Visit your nearest SFL center and book a Hearing Test today.
                            </strong>
                        </p>
                        <p className="h5">
                            Take the first step toward clearer hearing and a better quality of life with SFL Hearing
                            Solutions.
                        </p>
                        <a
                            href="tel:+919015706707"
                            className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold text-decoration-none"
                        >
                            <i className="fa-solid fa-phone me-2 mt-3"></i>Contact Us
                        </a>
                    </div>
                </div>
            </section>

            {/* Appointment Form */}

            <section className="enquiry-section py-5">
                <div className="container">
                    <h4 className="form-title section-title fw-bold">Book Your Hearing Test + Try Phonak Hearing Aids Today</h4>
                    <div className="row align-items-center py-3 g-4">
                        {/* Left Section */}
                        <div className="col-lg-6 image-wrapper">
                            <div className="image-box">
                                <img src={Bookhearingtest} alt="Main" className="main-img" />
                            </div>
                        </div>
                        {/* Right Section */}
                        <div className="col-lg-6">

                            <ShortLeadForm />

                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}

            <section className="container my-5">
                <h4 className="text-center mb-4">What Our Customers Say</h4>
                <div className="row g-4">
                    {[
                        {
                            name: "Pankaj Thakur",
                            review:
                                "Sound for life is excellent... They have good trained audiologist... Thanx Dr. Mohana for your kind suggestion and treatment.",
                            stars: 5,
                        },
                        {
                            name: "Archana Singh",
                            review:
                                "I am very satisfied with the products and services... trust this clinic, this is really reliable.",
                            stars: 4,
                        },
                        {
                            name: "Praphul Fernandis",
                            review:
                                "The staff was attentive and knowledgeable... creating a comfortable environment... overall service left a lasting positive impression.",
                            stars: 3.5,
                        },
                    ].map((t, idx) => (
                        <div className="col-md-6 col-lg-4" key={idx}>
                            <div className="card h-100 shadow-sm border-0 p-4">
                                <div className="mb-3">
                                    <i className="fa-solid fa-quote-left text-primary fa-2x"></i>
                                </div>
                                <p className="card-text">“{t.review}”</p>
                                <div className="d-flex align-items-center mt-3">
                                    <div>
                                        <h5 className="mb-0 fw-bold">{t.name}</h5>
                                        <div className="text-warning">
                                            {[...Array(Math.floor(t.stars))].map((_, i) => (
                                                <i key={i} className="fa-solid fa-star"></i>
                                            ))}
                                            {t.stars % 1 !== 0 && <i className="fa-solid fa-star-half-stroke"></i>}
                                            {[...Array(5 - Math.ceil(t.stars))].map((_, i) => (
                                                <i key={i} className="fa-regular fa-star"></i>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Video Testimonial */}

                <div className="row mt-5">
                    <div className="col-lg-8 mx-auto">
                        <h4 className="text-center mb-3">
                            <i className="fa-solid fa-video me-2 text-danger"></i>Watch What Our Patients Say
                        </h4>
                        <div className="ratio ratio-16x9 shadow-sm rounded">
                            <div>
                                <LiteYouTubeEmbed
                                    id="D9tDd5JXNUA"
                                    title="What’s new in Material Design for the web (Chrome Dev Summit 2019)"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Write Review Button */}

                <div className="text-center mt-5">
                    <a href="https://g.page/r/CcwF5e3cpqIrEAI/review" className="btn btn-custom btn-lg shadow">
                        <i className="fa-solid fa-pen-to-square me-2"></i>Write Your Review
                    </a>
                </div>
            </section>

            {/* WHY SFL */}

            <section className="container">
                <h5 className="text-center">
                    Why People Trust <span className="why">SFL Hearing Solutions</span>
                </h5>
                <p className="fs-5 text-center text-muted">
                    Trusted by thousands across India for hearing care, digital hearing aids, and expert consultation.
                </p>

                <div className="row g-4">
                    {[
                        {
                            icon: "fa-certificate",
                            title: "Certified Centre",
                            desc: "We are a trusted and certified hearing aid centre in India.",
                        },
                        {
                            icon: "fa-user-md",
                            title: "Experienced Audiologists",
                            desc: "Our team includes Professional Audiologists and Fitting experts.",
                        },
                        {
                            icon: "fa-users",
                            title: "50,000+ Happy Users",
                            desc: "We’ve helped over 50,000 happy customers hear better.",
                        },
                        {
                            icon: "fa-tags",
                            title: "Transparent Pricing",
                            desc: "Clear and honest pricing – no hidden charges.",
                        },
                        {
                            icon: "fa-clinic-medical",
                            title: "Clinics in India",
                            desc: "Visit us in Delhi, Noida, Ghaziabad, Gurgaon & more.",
                        },
                        {
                            icon: "fa-headset",
                            title: "Responsive Support",
                            desc: "We offer full range of brands & models.",
                        },
                    ].map((item, i) => (
                        <div className="col-md-6" key={i}>
                            <div className="d-flex align-items-start p-3 border rounded-4 shadow-sm h-100">
                                <div className="me-3 mt-1">
                                    <i className={`fas ${item.icon} whyus fa-2x whyus`}></i>
                                </div>
                                <div>
                                    <h5 className="fw-semibold mb-1">{item.title}</h5>
                                    <p className="mb-0 text-muted small">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA Section */}
            <section className="container my-5">
                <div className="bg-white border shadow rounded p-4">
                    <div className="text-center mb-4">
                        <h5 className="fw-bold">🎧Try Phonak Demo Today</h5>
                    </div>
                    <p className="fs-5 text-muted">
                        Depending on your needs, preferences, and financial situation, we assist you in selecting the
                        appropriate hearing aid for moderate loss, old age, or invisible choices.
                    </p>

                    <p className="fs-5 text-muted">Explore the latest models from <strong>Phonak</strong></p>
                    <div className="mb-4">
                        <h5 className="mb-3">
                            <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
                            <strong>Top Searches Our Users Look For:</strong>
                        </h5>
                        <div className="d-flex flex-wrap gap-2">
                            {[
                                "Phonak Audeo",
                                "Phonak Naída",
                                "Phonak Terra",
                                "Phonak Infinio",
                                "Phonak Marvel",
                                "Phonak Paradise Live"
                            ].map((item, index) => (
                                <span
                                    key={index}
                                    className="badge bg-light text-dark border px-3 py-2"
                                    style={{ fontSize: "0.9rem" }}
                                >
                                    <i className="fa-solid fa-tags me-1 text-primary"></i> {item}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="sfl-highlight-box text-center mt-4 p-4 rounded">
                        <h5 className="sfl-highlight-heading fw-semibold">
                            Sound For Life – Your ears deserve the best.
                        </h5>
                        <p className="sfl-highlight-subtext">
                            Trusted by 20,000+ users across India
                        </p>
                        <p className="sfl-highlight-subtext">
                            “Because every sound matters. That is Why Sound For Life”
                        </p>
                    </div>
                </div>
            </section>


            {/* Buy a Hearing Aid? Section */}
            <section className="container my-5">
                <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #006ea1, #006ea1)', color: '#fff' }}>
                    <div className="container text-center">
                        <h5 className="fw-bold mb-3">
                            <i className="fa-solid fa-calendar-check me-2"></i>
                            Visit Us at a Clinic Near You
                        </h5>
                        <p className="fs-5 mb-4">
                            Clinics in: Delhi | Noida | Gurugram | Faridabad | Ghaziabad
                        </p>

                        <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                            <a
                                href="tel:+919015706707"
                                className="btn btn-warning btn-lg fw-bold px-4 shadow"
                            >
                                <i className="fa-solid fa-phone me-2"></i> Book a Hearing Test
                            </a>

                            <a
                                href="https://wa.me/919015706707"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-light btn-lg fw-bold px-4 text-dark shadow"
                            >
                                <i className="fa-brands fa-whatsapp me-2"></i> Try Phonak Demo Today
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            {/* Ffooter Section */}

            <Footer />
        </>
    );
};

export default PhonakHearingAids;